let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("21YhU")).then(() => parcelRequire('cMnm9'));